import { ArchivalReason } from 'common/api-types/catalog';

export const CATALOG_KEY_ROOT = 'productCatalog';
export const EN_DASH = '–';
export const QUALITY_SCORE_INFO_ID = 'quality-score-info';

export const ARCHIVAL_REASON: ArchivalReason[] = [
  'LEGAL_RESTRICTION',
  'PRODUCT_NOT_MANUFACTURED',
  'DUPLICATE_OR_MANUAL_ERROR',
] as const;

export const MAX_IMAGE_SIZE = 10_485_760; // 10 MiB
